<template>
	<div>
		 <!-- breadcrumb area -->
		 <div class="breadcrumb-area breadcrumb-padding bg-img" :style="{backgroundImage:`url(${bgImg})`}">
		     <div class="container">
		         <div class="breadcrumb-content text-center">
		             <h2>筑壳客户端</h2>
		         </div>
		     </div>
		 </div>
		 <!-- Project area -->
		 <div class="section section-padding">
		     <div class="container">
		         <div class="row">
		             <div class="col-lg-6 col-md-6">
		                 <div class="contact-info-wrap" style="display: flex;align-items: center; justify-content: space-between;">
		                    <img src="@/assets/images/bg/and.png" alt="">
							<Icon type="logo-android" size="50" />
							<span>安卓客户端</span>
		                 </div>
		             </div>
		             <div class="col-lg-6 col-md-6">
		                 <div class="contact-info-wrap" style="display: flex;align-items: center; justify-content: space-between;">
		 					<img src="@/assets/images/bg/ios.png" alt="">
							<Icon type="logo-apple" size="50" />
							<span>IOS客户端</span>
		                 </div>
		             </div>
		         </div>
		     </div>
		 </div>
		 <!-- Service details area -->
		 <!-- <div class="section section-padding">
		     <div class="container">
		         <div class="service-details-content">
						<p>
							筑壳APP已上线应用市场。筑壳是一个装修领域的场景化展示平台，在筑壳里面你可以看到不一样的装修的案例呈现！
						</p>
		             <img src="@/assets/images/bg/zkbj.png" alt="">
		         </div>  
		     </div>
		 </div> -->
	</div>
</template>

<script>
	import { getCookies, removeCookies } from '@/libs/util'
	import {
		getShowList
	 } from '@/api'
	 export default {
	   data() {
			return {
				nameInfo: '',
				bgImg: require('../static/images/banner/banner-3.jpg'),
				showList: [],
			}
		},
		created() {
		    this.getShowList()
		},
		computed: {
			isLogin() {
			  return getCookies("webtoken");
			},
		},
		methods:{
			
			// 获取展厅详情
			async getShowList() {
			  const res = await getShowList()
			  this.showList = res.data
			},
		}
	}
</script>

<style>
</style>
